// no itx for this file

import { buttonActions, buttonActionsSensitiv } from "../KnxMappings/Button/Actions";
import { buttonStatus, buttonStatusSensitiv } from "../KnxMappings/Button/Status";
import { ChannelType } from "../models/ChannelType";
import Signal from "../models/Signal";
import SignalType from "../models/SignalType";
import SignalTypes from "../models/SignalTypes";
import { determineSignalType, matchN } from "./determineActorComObjectFunction";

////////////////////////////////////////////////////////////////////////////////
const stateNames = ["state", "status", "indicator", "feedback"];
const actionNames = [
  "send",
  "absolute and status", // MDT 	BE-GTSP6TX.01S
  "command",
  "control",
];

export default function determineButtonComObjectFunction(signal: Signal, channelType?: ChannelType) {
  var buttonStatusList = buttonStatus;
  var buttonActionsList = buttonActions;
  if (channelType) {
    buttonStatusList = buttonStatusSensitiv;
    buttonActionsList = buttonActionsSensitiv;
  }

  let isStateFunction =
    // signal.a.WriteFlag == "Enabled" || // => sometimes enabled are action signals
    matchN(stateNames, signal.knxFunctionTextEN.toLocaleLowerCase() || signal.knxTextEN) ||
    matchN(stateNames, signal.knxTextENForDetectionRaw?.toLocaleLowerCase() || signal.knxTextEN);

  let isActionFunction =
    // signal.a.WriteFlag == "Enabled" || // => sometimes enabled are action signals
    matchN(actionNames, signal.knxFunctionTextEN.toLocaleLowerCase()) ||
    matchN(actionNames, signal.knxTextENForDetectionRaw?.toLocaleLowerCase() || signal.knxTextEN);

  ////////////////////////////////////////////////////////////////////////////////
  // MWE 1.1.2023
  //
  // if a signal has explizit DISABLED transmission
  // it must be a status signal !!!
  //
  // lex MDT SCN-RTR55S.01, and should be true for all MDT products
  //
  // must be checked if it is "set wrong" for other manufators
  //

  if ((signal as any).a && (signal as any).a.TransmitFlag == "Disabled") {
    isActionFunction = false;
    isStateFunction = true;
  }
  ////////////////////////////////////////////////////////////////////////////////

  var f: { signalType: SignalType; id?: string } = {
    signalType: SignalTypes.Unknown,
  };
  if (isStateFunction && !isActionFunction) {
    // WriteFlag  is not set correct for all devices ie GIRA xxxx

    f = determineSignalType(signal, buttonStatusList, channelType);
  } else {
    f = determineSignalType(signal, buttonActionsList, channelType);

    if (f.signalType.name === SignalTypes.Unknown.name) {
      // signal is a signal signal
      const id1 = f.id;
      f = determineSignalType(signal, buttonStatusList, channelType);

      f.id = f.id || id1; // for better debugging if buttonActionsList returns channelType.Unknown
    }
  }
  signal.type = f.signalType;
  if (f.id) {
    signal.determinedFromId = f.id;
  } else {
    signal.determinedFromId = "";
  }
}
